import { FC } from 'react';
import { useLocation, useParams } from 'react-router-dom';

import { GetExternalServiceStatusFn } from '../../pages/StackedCoverPage/hooks/useContentStackEventHandlers';
import { StackedCoverPage } from '../../pages/StackedCoverPage/StackedCoverPage';
import { SuperCoverPageContext } from '../../pages/StackedCoverPage/SuperCoverPageContext';
import { AssetNotFound } from '../errorPage/AssetNotFound';
import { PlayerFutureAssetDialog } from '../playerDialog';

import { CoverPagePath, CoverPagePaths, PlayerDialogues } from './coverpage.types';
import { CoverPageChannel } from './CoverPageChannel';
import { RedirectOldCoverPageVod } from './RedirectOldCoverPageVod';
import { RedirectOldTvSeriesCoverPage } from './RedirectOldTvSeriesCoverPage';

export type CoverPageRouterProps = Omit<PlayerDialogues, 'futureAssetDialogue'> & {
  getExternalServiceStatus: GetExternalServiceStatusFn;
};

export const CoverPageRouter: FC<CoverPageRouterProps> = ({ getExternalServiceStatus, ...dialogs }) => {
  const { type, id } = useParams<{ id: string; type: CoverPagePath }>();
  const { pathname } = useLocation();

  if (!id) {
    return <AssetNotFound contextInfo="CoverPageRouter, missing id" />;
  }

  const coverPageProps: PlayerDialogues & { assetId: string } = {
    assetId: id,
    futureAssetDialogue: PlayerFutureAssetDialog,
    ...dialogs,
  };

  if (
    pathname.includes(`/${CoverPagePaths.STACKED_SERIES}/`) ||
    pathname.includes(`/${CoverPagePaths.STACKED_MOVIE}/`)
  ) {
    return (
      <SuperCoverPageContext.Provider value={{ getExternalServiceStatus }}>
        <StackedCoverPage id={id} />
      </SuperCoverPageContext.Provider>
    );
  }

  switch (type?.toLowerCase()) {
    case CoverPagePaths.LIVE:
      const { assetId, ...liveProps } = coverPageProps;
      return <CoverPageChannel channelId={assetId} {...liveProps} />;
    case CoverPagePaths.VOD:
      return <RedirectOldCoverPageVod assetId={id} />;
    case CoverPagePaths.SERIES:
      return <RedirectOldTvSeriesCoverPage seriesId={id} />;
    default:
      return <AssetNotFound contextInfo="default return after all redirects" />;
  }
};
